<template>
  <section>
    <div class="tab-wrap">
      <template v-for="item in gameList" :key="item.code">
        <button type="button" class="tab-item" :class="{ active: `${item.code}` == reqData.groupCode }" @click="changeListType" :value="item.code">{{ item.codeName }}</button>
      </template>

    </div>

    <div class="main-contents-wrapper">
      <article class="total-info-container">
        <button type="button" class="btn-layout btn-blue" @click="onAddCode()">{{isAdd? '추가 취소':'추가'}}</button>
      </article>
    </div>
    <div class="main-contents-wrapper">
      <div class="table-wrapper">

        <table class="mainTable">
          <table-head-sorting :headInfo="headInfo" @sort="onSort" :orderColumn="reqData.orderName" :orderType="reqData.orderType"/>
          <tbody>
          <template v-if="gameCodeList.length !== 0">
            <tr v-if="isAdd">
              <td><input type="text" v-model="add.groupCodeName"></td>
              <td><input type="text" v-model="add.groupCodeNameEN"></td>
              <td><input type="text" v-model="add.code"></td>
              <td><input type="text" v-model="add.codeName"></td>
              <td><input type="text" v-model="add.codeNameEN"></td>
              <td><input type="text" v-model="add.ord"></td>
              <td>
                <select v-model="add.useYn">
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </td>
              <td><input type="text" v-model="add.kgonVendor"></td>
              <td><input type="text" v-model="add.kgonLobby"></td>
              <td><input type="text" v-model="add.kgonCode"></td>
              <td><input type="text" v-model="add.tripleVendor"></td>
              <td><input type="text" v-model="add.tripleLobby"></td>
              <td><input type="text" v-model="add.tripleCode"></td>
              <td><input type="text" v-model="add.sdApiVendor"></td>
              <td><input type="text" v-model="add.sdApiLobby"></td>
              <td><input type="text" v-model="add.sdApiCode"></td>
              <td style="width: 10%">
                <div class="status-change-btn-wrap">
                  <button class="btn-innerTable btn-status-change wait" type="button" @click="onAddData()">저장</button>
                </div>
              </td>
            </tr>
            <tr v-for="(item, idx) in gameCodeList" :key="idx">
              <template v-if="!item.isModify">
                <td>{{ item.groupCodeName }}</td>
                <td>{{ item.groupCodeNameEN }}</td>
                <td>{{ item.code }}</td>
                <td>{{ item.codeName }}</td>
                <td>{{ item.codeNameEN }}</td>
                <td>{{ item.ord }}</td>
                <td>{{ item.useYn }}</td>
                <td>{{ item.kgonVendor }}</td>
                <td>{{ item.kgonLobby }}</td>
                <td>{{ item.kgonCode }}</td>
                <td>{{ item.tripleVendor }}</td>
                <td>{{ item.tripleLobby }}</td>
                <td>{{ item.tripleCode }}</td>
                <td>{{ item.sdApiVendor }}</td>
                <td>{{ item.sdApiLobby }}</td>
                <td>{{ item.sdApiCode }}</td>
                <td style="width: 10%">
                  <div class="status-change-btn-wrap">
                    <button class="btn-innerTable btn-status-change wait" type="button" @click="onModify(item, idx)">수정</button>
                  </div>
                </td>
              </template>
              <template v-else>
                <td><input type="text" v-model="item.groupCodeName"></td>
                <td><input type="text" v-model="item.groupCodeNameEN"></td>
                <td><input type="text" v-model="item.code"></td>
                <td><input type="text" v-model="item.codeName"></td>
                <td><input type="text" v-model="item.codeNameEN"></td>
                <td><input type="text" v-model="item.ord"></td>
                <td>
                  <select v-model="item.useYn">
                    <option value="Y">Y</option>
                    <option value="N">N</option>
                  </select>
                </td>
                <td><input type="text" v-model="item.kgonVendor"></td>
                <td><input type="text" v-model="item.kgonLobby"></td>
                <td><input type="text" v-model="item.kgonCode"></td>
                <td><input type="text" v-model="item.tripleVendor"></td>
                <td><input type="text" v-model="item.tripleLobby"></td>
                <td><input type="text" v-model="item.tripleCode"></td>
                <td><input type="text" v-model="item.sdApiVendor"></td>
                <td><input type="text" v-model="item.sdApiLobby"></td>
                <td><input type="text" v-model="item.sdApiCode"></td>
                <td style="width: 10%">
                  <div class="status-change-btn-wrap">
                    <button class="btn-innerTable btn-status-change wait" type="button" @click="onSaveModify(item, idx)">저장</button>
                    <button class="btn-innerTable btn-status-change wait" type="button" @click="onModifyCancel(idx)">취소</button>
                  </div>
                </td>
              </template>
            </tr>
          </template>
          <template v-else>
            <td colspan="14">데이터가 없습니다.</td>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import SearchFilter from "@/components/common/SearchFilter";
import DateSelector from "@/components/common/DateSelector";
import TableHeadSorting from "@/components/main/table/HeadSorting.vue";
import UiCheck from "@/components/ui/UiCheckSet";
import subTitle from "@/components/main/PageSubTitle";
import {mapGetters} from "vuex";
import {gameCodeRegist, gameCodeUpdate, getGameCodeList} from "@/api/setting";

export default {
  name: "GameCodeList",
  components: {
    SearchFilter,
    DateSelector,
    TableHeadSorting,
    UiCheck,
    subTitle
  },
  data: function () {
    return {
      tableData: {},
      headInfo: {
        fstColumn: false,
        dataList: []
      },
      reqData: {
        page: 1,
        count_per_list: "30",
        groupCode : "casino",
        orderName : "code",
        orderType : "ASC",
      },
      gameCodeList: [],
      isAdd: false,
      add: {
        groupCode: ''
      },
      origin: null,
      modifyIndex: null
    };
  },
  methods: {
    async onSaveModify(item, index) {
      const updateData = JSON.parse(JSON.stringify(item))
      delete updateData.isModify
      updateData.groupCode = this.reqData.groupCode
      const result = await gameCodeUpdate(updateData)
      if (result.resultCode === '0') {
        alert('정상적으로 수정되었습니다.')
        this.onModifyCancel()
        await this.lastDataRefector()
      }
    },
    onModifyCancel () {
      if (this.origin) {
        this.gameCodeList[this.modifyIndex] = this.origin
        this.gameCodeList[this.modifyIndex].isModify = false
        this.origin = null
        this.modifyIndex = null
      }
    },
    onModify (item, index) {
      this.onModifyCancel()

      this.modifyIndex = index
      this.origin = JSON.parse(JSON.stringify(item))

      item.isModify = true
    },
    async onAddData () {
      if (this.isAdd) {
        this.add.groupCode = this.reqData.groupCode
        const result = await gameCodeRegist(this.add)
        if (result.resultCode === '0') {
          alert('정상적으로 추가되었습니다.')
          this.onModifyCancel()
          await this.lastDataRefector()
          this.add = {}
          this.isAdd = false
        }
      }
    },
    async onAddCode() {
      this.isAdd = !this.isAdd
    },
    onSort (key, type) {
      this.reqData.orderType = type
      this.reqData.orderName = key
      this.lastDataRefector()
    },
    async changeListType(evt) {
      const target = evt.target;
      const chooseType = target.value;

      this.reqData.groupCode = chooseType
      this.reqData.orderName = 'code'
      this.reqData.orderType = 'ASC'

      this.lastDataRefector()
    },
    async lastDataRefector() {
      console.log('lastDataRefector')
      window.scrollTo(0, 0);

      const listRes = await getGameCodeList(this.reqData);
      this.headInfo.dataList = []

      if (listRes.resultCode === '0') {
        const colList = listRes.data.colList
        for(let i=0,iLen=colList.length;i<iLen;i++) {
          const item = colList[i]
          const head = {
            key: item.col_name
          }
          if(item.col_name === 'code' || item.col_name === 'ord') {
            head.sort = true
          }
          this.headInfo.dataList.push(head)
        }
        this.headInfo.dataList.push({key: 'empty'})

        // this.headInfo.dataList = listRes.data.colList
        this.gameCodeList = listRes.data.gameCodelist;
      }
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      'gameList'
    ])
  },
  async created() {
    await this.setGameList();
    console.log(this.gameList)
    await this.lastDataRefector()
  }
};
</script>

<style scoped >
input {
  width: 100%;
}

.main-sub-data-item > div {
  padding: 8px 0;
  text-align: center;
  box-sizing: border-box;
}
.btn-total-data > i {
  margin-right: 5px;
}
.btn-total-data > span {
  font-weight: 700;
  letter-spacing: 2px;
}
.searchwrap {margin: 0 20px;}
</style>
